import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { verifyTokenApi } from "../api/parentApi";

const VerifyToken = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    React.useEffect(() => {
        const handleUrlToken = async () => {
            const urlToken =
                searchParams.get("accessToken") || searchParams.get("token");

            console.log("URL Token:", urlToken);

            if (!urlToken) {
                console.log("No token found");
                navigate("/");
                window.dispatchEvent(new Event("openLoginDialog"));
                return;
            }

            try {
                const result = await verifyTokenApi(urlToken);
                console.log("API Result:", result);

                if (result?.meta?.success) {
                    const parentData = result.response;

                    localStorage.setItem(
                        "parentToken",
                        parentData.token || urlToken
                    );

                    const pInfo = {
                        id: parentData.gurardianId,
                        name: parentData.GurardianName,
                        email: parentData.GurardianEmailId,
                        planName: parentData.planName || "Free Plan",
                        planPrice: parentData.planPrice || 0,
                    };

                    localStorage.setItem("parentInfo", JSON.stringify(pInfo));
                    window.dispatchEvent(new Event("userUpdated"));

                    // ✅ Clean URL
                    window.history.replaceState({}, document.title, "/verify");

                    // ✅ Redirect
                    navigate("/pricing#plans");
                } else {
                    console.log("Token verification failed");
                    navigate("/");
                    window.dispatchEvent(new Event("openLoginDialog"));
                }
            } catch (error) {
                console.error("Token verification error:", error);
                navigate("/");
                window.dispatchEvent(new Event("openLoginDialog"));
            }
        };

        handleUrlToken();
    }, []);

    return <div>Verifying your session...</div>;
};

export default VerifyToken;